import React, { useState, useEffect } from 'react';
import { FC } from 'react';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useCart from '@hooks/useCart';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import ContentTemplate from '@ui/Content/Content';
import PackageTemplate from '@ui/Package/Package';
import Title from '@ui/SectionTitle/Title';
import Link from 'next/link';
import { publicAssets } from '@utils/url.utils';
import { SUBSCRIPTION_PACKAGES } from '../../constants/packages';
import { useGTM } from '@hooks/useGTM';
import {
    Background,
    Description,
    DescriptionCoupons,
    DescriptionDiscount,
    Highlighted,
    Small,
    Big,
    Package,
    PackageDescriptionItem,
    PackageDescriptionList,
    PackageDescriptionAndPrices,
    PackageDescriptionPrices,
    PackageImage,
    PackageLabel,
    PackagePrice,
    PreTitle,
    PackagePriceWithoutVat,
    PackagePriceSection,
    PackageTitle,
    Packages,
} from './Packages.elements';

export interface PackagesProps { }

const PackagesTemplate: FC<PackagesProps> = () => {
    const { t } = useTranslations();

    const { addOrUpdateItemInCart } = useCart();

    const { viewItem } = useGTM();

    useEffect(() => {
        if (SUBSCRIPTION_PACKAGES) {
            SUBSCRIPTION_PACKAGES?.forEach((item) => {
                const data = {
                    value: Number(item?.price.replace(' ', '')),
                    currency: 'CZK',
                    items: [{
                        item_id: item?.eso9,
                        item_name: item?.title,
                        item_brand: 'Studio W',
                        price: Number(item?.price.replace(' ', '')),
                        quantity: 1,
                    }]
                }
                viewItem(data)
            });
        }
    }, [SUBSCRIPTION_PACKAGES]);

    return (
        <Background>
            { /* <PreTitle dangerouslySetInnerHTML={{ __html: t('packages.intro.label') }} />
            */}
            {new Date() >= new Date("2026-09-09 04:00:00") && new Date() <= new Date("2026-10-16 23:59:59") && (
                <ContentTemplate mobileSidePadding={20}>
                    <DescriptionCoupons>

                        <Big><strong>15 % sleva na roční soft skills předplatné pro váš tým!</strong></Big><br />

                        Pokračujte po létě v rozvoji dovedností s balíkem <strong>Leadership & Skills for Future</strong> (až pro 5 osob). <br />V košíku zadejte <Highlighted>do 16. 10.</Highlighted> kód <strong>ZPATKYDOPRACE15</strong>.<br />

                    </DescriptionCoupons>
                </ContentTemplate>
            )}
            <ContentTemplate mobileSidePadding={20}>
                <Title isBlack>{t('packages.intro.title')}</Title>
                <Description>{t('packages.intro.description')}</Description>
            </ContentTemplate>
            <ContentTemplate mobileSidePadding={20}>
                <Title isBlack>{t('packages.title')}</Title>
                <Packages>
                    {SUBSCRIPTION_PACKAGES.map((subscriptionPackage, subscriptionPackageKey) => (
                        <Package key={subscriptionPackageKey}>
                            <PackageImage src={publicAssets(`/${subscriptionPackage.key}.png`)} />
                            <PackageTitle href={subscriptionPackage?.redirectLink}>
                                <PackageTemplate symbol={subscriptionPackage.icon} color={subscriptionPackage.color} />{' '}
                                {subscriptionPackage.title}
                            </PackageTitle>
                            <PackageLabel>{t('packages.label1')}</PackageLabel>
                            <PackageLabel>{t('packages.label2')}</PackageLabel>
                            <PackageDescriptionAndPrices>
                                <PackageDescriptionList>
                                    {subscriptionPackage.benefits.map((benefit, benefitKey) => (
                                        <PackageDescriptionItem key={benefitKey}>
                                            <IconTemplate name={Icons.CheckThin} />
                                            <span dangerouslySetInnerHTML={{ __html: benefit }} />
                                        </PackageDescriptionItem>
                                    ))}
                                </PackageDescriptionList>

                                <PackageDescriptionPrices>

                                    <PackagePriceSection>
                                        <PackagePrice>{subscriptionPackage.priceWithoutVat} Kč bez DPH / rok</PackagePrice>
                                    </PackagePriceSection>
                                    <PackagePriceSection>
                                        <PackagePriceWithoutVat>
                                            {subscriptionPackage.price} Kč s DPH / rok
                                        </PackagePriceWithoutVat>
                                    </PackagePriceSection>
                                    <ButtonTemplate
                                        marginTop={20}
                                        marginBottom={20}
                                        text={t('packages.package.button')}
                                        onClick={() => addOrUpdateItemInCart(subscriptionPackage.moduleId, 1)}
                                    />
                                </PackageDescriptionPrices>

                            </PackageDescriptionAndPrices>
                        </Package>
                    ))}
                </Packages>
                <DescriptionDiscount>
                    Při zakoupení <strong>jakéhokoliv balíku</strong> získáte se slevovým kódem <strong>balik20</strong> slevu 20 % na vstupenky na naše <Link href="/konference"><strong>Kongresy | Konference</strong></Link> pro všechny členy vašeho předplatného.
                </DescriptionDiscount>
            </ContentTemplate>
        </Background>
    );
};

export default PackagesTemplate;

